export default __webpack_public_path__ + "static/media/ico-chatbot.9d0db7c3.svg";